var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Renderer2 } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
var ModalFreeSpinsComponent = /** @class */ (function (_super) {
    __extends(ModalFreeSpinsComponent, _super);
    function ModalFreeSpinsComponent(ref, formBuilder, auth, elRef, renderer, router, activatedRoute, http) {
        var _this = _super.call(this, elRef, renderer) || this;
        _this.ref = ref;
        _this.formBuilder = formBuilder;
        _this.auth = auth;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.http = http;
        _this.loading = false;
        _this.errors = null;
        _this.person = '';
        _this.freeSpins = 10;
        return _this;
    }
    ModalFreeSpinsComponent.prototype.ngAfterViewInit = function () { };
    ModalFreeSpinsComponent.prototype.close = function () {
        this.auth.guestWon = true;
        this.ref.close(0);
    };
    ModalFreeSpinsComponent.prototype.reject = function () {
        this.auth.guestWon = true;
        this.ref.dismiss(1);
    };
    return ModalFreeSpinsComponent;
}(AnimatedModalComponent));
export { ModalFreeSpinsComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/free-spins-modal.component.ts.pre-build-optimizer.js